var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blockHeight"},[_c('i',{staticClass:"el-icon-refresh"}),_c('span',[_vm._v(_vm._s(_vm.$store.state.wallet.blockNumber))])])}
var staticRenderFns = []

export { render, staticRenderFns }